// Header.tsx — الشريط العلويّ الثابت (شريط shadcn-admin): زرّ طيّ القائمة + أدوات (لغة/مستخدم).
// تخصيص الهويّة اللونيّة أصبح محصورًا في صفحة إعدادات النظام (SystemSettingsPage) فقط.
import { Menu } from 'lucide-react';
import { Button } from '../components/ui/button';
import { LanguageSwitcher } from './LanguageSwitcher';
import { NotificationBell } from './NotificationBell';
import { UserMenu } from './UserMenu';

interface HeaderProps {
	onToggleSidebar: () => void;
}

export function Header({ onToggleSidebar }: HeaderProps) {
	return (
		<header className="sticky top-0 z-30 flex h-14 items-center justify-between gap-2 border-b border-border bg-background/80 px-4 backdrop-blur">
			<div className="flex items-center gap-2">
				<Button variant="ghost" size="icon" onClick={onToggleSidebar} aria-label="toggle-sidebar">
					<Menu className="size-5" />
				</Button>
			</div>
			<div className="flex items-center gap-1">
				<NotificationBell />
				<LanguageSwitcher />
				<UserMenu />
			</div>
		</header>
	);
}
